import CanvasParticles from "../../components/CanvasParticles";
import SearchSection from "./components/SearchSection";
import ConnectWithSupportSection from "./components/ConnectWithSupport";
import PopularQuestionsSection from "./components/PopularQuestions";
import SubscriptionManagementSection from "./components/SubscriptionManagement";
import BillingPaymentsSection from "./components/BillingPayments";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <div className="min-h-screen font-sans relative overflow-x-hidden bg-[#0a0a0a]">
      {/* Background layers */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[#0a0a0a]" />
      </div>

      {/* Hero with particles */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <CanvasParticles />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-[#0a0a0a]" />
        <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-16 md:py-24">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col items-center text-center">
              <div className="inline-block px-4 py-2 rounded-full border border-white/20 mb-6 md:mb-8">
                <span className="text-white/60 text-xs md:text-sm tracking-wider uppercase">Support Center</span>
              </div>
              <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight">
                How can we<br /><span className="font-normal italic">help you?</span>
              </h1>
              <p className="text-white/50 text-base md:text-lg mt-4 max-w-xl">
                Find answers to billing, subscription, and account questions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-6 relative z-10">
        <ConnectWithSupportSection />
        <PopularQuestionsSection />

        <div className="space-y-6">
          <SubscriptionManagementSection />
          <BillingPaymentsSection />
          <CTASection />
        </div>

        <FooterSection />
      </main>
    </div>
  );
}